import { COMPANY } from "../data/site";
import { PageHeader } from "../components/Reveal";

export default function Legal() {
  return (
    <div data-testid="legal-page">
      <PageHeader overline="Informations légales" title="Mentions légales" />
      <section className="max-w-3xl mx-auto px-5 md:px-10 py-20 prose-sm">
        <div className="space-y-10 text-text-muted leading-relaxed">
          <Block title="Éditeur du site">
            <p><strong className="text-navy">{COMPANY.name}</strong></p>
            <p>{COMPANY.address}, {COMPANY.zip} {COMPANY.city}</p>
            <p>Téléphone : {COMPANY.phone}</p>
            <p>Email : {COMPANY.email}</p>
            <p>Zone d'intervention : {COMPANY.area}</p>
          </Block>
          <Block title="Activité">
            <p>Installation, mise en service, dépannage et maintenance de systèmes énergétiques : climatisation, pompe à chaleur, ventilation et chauffage.</p>
          </Block>
          <Block title="Hébergement">
            <p>Ce site est hébergé par son prestataire technique. Les coordonnées complètes de l'hébergeur peuvent être communiquées sur demande.</p>
          </Block>
          <Block title="Propriété intellectuelle">
            <p>L'ensemble des contenus présents sur ce site (textes, images, logo) est la propriété de {COMPANY.name}, sauf mention contraire. Toute reproduction sans autorisation est interdite.</p>
          </Block>
          <Block title="Données personnelles">
            <p>Les informations collectées via les formulaires (devis, contact, rendez-vous) sont destinées exclusivement à {COMPANY.name} pour traiter vos demandes. Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression de vos données en nous contactant à {COMPANY.email}.</p>
          </Block>
          <Block title="Cookies">
            <p>Ce site peut utiliser des cookies à des fins de mesure d'audience et d'amélioration de l'expérience utilisateur.</p>
          </Block>
        </div>
      </section>
    </div>
  );
}

function Block({ title, children }) {
  return (
    <div>
      <h2 className="font-display text-xl font-extrabold text-navy mb-3">{title}</h2>
      {children}
    </div>
  );
}
